import { interpolate } from "./interpolate";
import { Route } from "./Route";

/** The learner reads the brief, work and correction at the same address. */
export const toAssignmentHref = (assignmentId: string) => interpolate(Route.MY_WORKSPACE_ASSIGNMENT, { assignmentId });
